import img00 from "./00.webp";
import img01 from "./01.webp";
import img02 from "./02.webp";
import img03 from "./03.webp";
import img04 from "./04.webp";
import img05 from "./05.webp";
import img06 from "./06.webp";
import img07 from "./07.webp";
import img08 from "./08.webp";
import img09 from "./09.webp";
import img10 from "./10.webp";
import img11 from "./11.webp";
import img12 from "./12.webp";
import img13 from "./13.webp";
import img14 from "./14.webp";

export default [
  img00,
  img01,
  img02,
  img03,
  img04,
  img05,
  img06,
  img07,
  img08,
  img09,
  img10,
  img11,
  img12,
  img13,
  img14,
];
